module.exports = {

  title: '掌上学',

  /**
   * @type {boolean} true | false
   * @description 是否固定页眉
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description 是否在侧边栏中显示徽标
   */
  sidebarLogo: true,
  /**
   * @type {boolean} true | false
   * @description 是否需要tagsView
   */
  tagsView: true
}
